import type { Macronutrients, NutrientProfile } from "./nutrients";

export const KCAL_PER_GRAM_PROTEIN = 4;
export const KCAL_PER_GRAM_CARBOHYDRATE = 4;
export const KCAL_PER_GRAM_FAT = 9;

/** Calories are always derived from macros; supplied label calories are never authoritative. */
export function caloriesFromMacros(macros: Macronutrients): number {
  return (
    macros.proteinGrams * KCAL_PER_GRAM_PROTEIN +
    macros.carbohydrateGrams * KCAL_PER_GRAM_CARBOHYDRATE +
    macros.fatGrams * KCAL_PER_GRAM_FAT
  );
}

export function caloriesFromNutrients(nutrients: NutrientProfile): number {
  return caloriesFromMacros(nutrients.macros);
}
